export const FETCH_SUGGESTED_QUESTION = 'app/fetchSuggestedQuestions';
export const FETCH_FAQS = 'app/fetchFaqs';
export const FETCH_FEATURES = 'get/user-features';
export const EVENT_LOGS_ON_SERVER = "auth/currencies";
